import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../shared/lib/http-client";
import type { WidgetConfig } from "../lib/config-schema";

/**
 * Fetch configuration from server
 */
async function fetchConfig(): Promise<WidgetConfig> {
  return apiClient.get<WidgetConfig>("/api/config");
}

/**
 * Hook to fetch configuration using TanStack Query
 */
export function useConfig() {
  return useQuery({
    queryKey: ["config"],
    queryFn: fetchConfig,
    staleTime: 1000 * 60 * 10, // Consider config fresh for 10 minutes
    gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
    retry: 3, // Retry failed requests 3 times (config is critical)
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
  });
}
